export default "__VITE_ASSET__Cm4vXb4j__"